import { PostHeaderElement } from '@components/Post';
import { Resource } from '@core';
import { GuidesAndTipsDocument } from '@core/content';
import { getSeeMoreRelatedMerchantsLink } from '@navigation';
import { mc } from '@styles';
import React, { FC } from 'react';

import { PostTableOfContents } from '../TableOfContents';
import DownloadAppSection from './components/DownloadAppSection';
import MerchantCard from './components/MerchantCard';
import RelatedTopicCard from './components/RelatedTopicCard';
import Section from './components/SectionContainer';
import Subsection from './components/SubsectionContainer';

interface Props {
  relatedPosts?: GuidesAndTipsDocument[];
  contents: PostHeaderElement[];
  active?: string;
  hasSearch?: boolean;
  relatedMerchants?: Resource[];
  hasDownloadBar?: boolean;
  onTableContentsItemClick?: (itm: PostHeaderElement) => void;
}

export const PostSidebar: FC<Props> = ({
  hasDownloadBar = true,
  contents,
  relatedPosts = [],
  relatedMerchants = [],
  active,
  onTableContentsItemClick,
}) => {
  return (
    <aside className="lg:sticky" style={{ top: 48 }}>
      <Section testId="post-sidebar-table-of-contents">
        <PostTableOfContents active={active} contents={contents} onItemClick={onTableContentsItemClick} />
      </Section>
      {/* Merchants */}
      {!!relatedMerchants.length && (
        <Section testId="post-sidebar-partners" className="mt-6">
          <Subsection title="Partners in this Article">
            {relatedMerchants.map((m, index) => (
              <MerchantCard key={m.id} className={mc(index > 0 && 'mt-10 xl:mt-6')} merchant={m} />
            ))}
            <div className="mt-6">
              <a
                className={mc(
                  'font-graphik leading-normal font-bold text-dark hover:text-accent-orange',
                  'underline underline-offset-8 hover:underline',
                )}
                href={getSeeMoreRelatedMerchantsLink(relatedMerchants)}
              >
                {'See more'}
              </a>
            </div>
          </Subsection>
        </Section>
      )}
      {/* Merchants */}
      {/* Related posts */}
      {!!relatedPosts.length && (
        <Section className="mt-6">
          <Subsection title="Related Topics" contentClassName="flex flex-col">
            {relatedPosts.map((p, index) => (
              <RelatedTopicCard key={p.id} className={mc(index > 0 && 'mt-6')} document={p} />
            ))}
          </Subsection>
        </Section>
      )}
      {/* Related posts */}
      {!!hasDownloadBar && (
        <Section className="mt-6">
          <DownloadAppSection className="px-8" />
        </Section>
      )}
    </aside>
  );
};

export default PostSidebar;
